// N.B. Correlates to values in `AuthenticationMethod::class`

// biome-ignore lint/style/noEnum: Consistent way of handling strings
export enum AuthenticationMethod {
  EmailPassword = "email_password",
  BankId = "bank_id",
}
